import _classCallCheck from "/var/www/commonsku/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/var/www/commonsku/node_modules/@babel/runtime/helpers/esm/createClass.js";
// eslint-disable-next-line no-restricted-syntax
export var Observable = /*#__PURE__*/function () {
  function Observable(onFirstSubscribe) {
    _classCallCheck(this, Observable);
    this.onFirstSubscribe = onFirstSubscribe;
    this.observers = [];
  }
  _createClass(Observable, [{
    key: "subscribe",
    value: function subscribe(f) {
      var _this = this;
      this.observers.push(f);
      if (this.observers.length === 1 && this.onFirstSubscribe) {
        this.onLastUnsubscribe = this.onFirstSubscribe(this) || undefined;
      }
      return {
        unsubscribe: function unsubscribe() {
          _this.observers = _this.observers.filter(function (other) {
            return f !== other;
          });
          if (!_this.observers.length && _this.onLastUnsubscribe) {
            _this.onLastUnsubscribe();
          }
        }
      };
    }
  }, {
    key: "notify",
    value: function notify(data) {
      this.observers.forEach(function (observer) {
        return observer(data);
      });
    }
  }]);
  return Observable;
}();
export function mergeObservables() {
  for (var _len = arguments.length, observables = new Array(_len), _key = 0; _key < _len; _key++) {
    observables[_key] = arguments[_key];
  }
  return new Observable(function (globalObservable) {
    var subscriptions = observables.map(function (observable) {
      return observable.subscribe(function (data) {
        return globalObservable.notify(data);
      });
    });
    return function () {
      return subscriptions.forEach(function (subscription) {
        return subscription.unsubscribe();
      });
    };
  });
}